import { Dispatch, SetStateAction, useEffect } from 'react';
import { useAppSelector } from '../../redux/hooks';
import { selectedReportsFilter } from '../../redux/reducers/filterReportsSlice';
import { useLazyLoadQuery } from 'react-relay';
import { SkillsProgressReportStudentsQuery } from '../../graphQLOperations/__generated__/SkillsProgressReportStudentsQuery.graphql';
import { skillProgressReportStudentsQuery } from '../../graphQLOperations/Skills';
import { SkillResult } from '../../models/Skill';

interface Student {
  id: string;
  firstName: string;
  lastName: string;
  publicUserId: string;
}

interface Props {
  lazyLoading: boolean;
  setLazyLoading: Dispatch<SetStateAction<boolean>>;
  studentSkillProgressDetailInput?: {
    skillId: string;
    skillResult: SkillResult;
    count: number;
  };
  pageInfo:
    | {
        endCursor: string | null | undefined;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor: string | null | undefined;
      }
    | undefined;
  setPageInfo: Dispatch<
    SetStateAction<
      | {
          endCursor: string | null | undefined;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor: string | null | undefined;
        }
      | undefined
    >
  >;

  setStudents: Dispatch<SetStateAction<Student[]>>;
  fetchKeyScroll: number;
  setLastCall: Dispatch<SetStateAction<boolean>>;
}

const QuerySkillsProgressReportStudents = ({
  setLastCall,
  fetchKeyScroll,
  setStudents,
  lazyLoading,
  setLazyLoading,
  pageInfo,
  setPageInfo,
  studentSkillProgressDetailInput,
}: Props) => {
  const reportsFilterRedux = useAppSelector(selectedReportsFilter);
  const { skillProgressReportStudents } = useLazyLoadQuery<SkillsProgressReportStudentsQuery>(
    skillProgressReportStudentsQuery,
    {
      first: 10,
      skip: lazyLoading && studentSkillProgressDetailInput === undefined,
      after: lazyLoading && pageInfo?.hasNextPage ? pageInfo?.endCursor : undefined,
      filter: {
        skillResult: studentSkillProgressDetailInput?.skillResult || ('' as SkillResult),
        skillId: studentSkillProgressDetailInput?.skillId ?? '',
        classIds: reportsFilterRedux?.classes?.length ? reportsFilterRedux?.classes?.map(cl => cl?.id) : [],
        gradeLevelIds: reportsFilterRedux?.grades?.length
          ? reportsFilterRedux?.grades?.map(grade => grade?.id)
          : undefined,
      },
    },
    { fetchKey: fetchKeyScroll },
  );

  useEffect(() => {
    if (studentSkillProgressDetailInput && skillProgressReportStudents && lazyLoading) {
      setPageInfo(skillProgressReportStudents?.pageInfo);
      setLastCall(!skillProgressReportStudents?.pageInfo?.hasNextPage);
      setLazyLoading(false);
      setStudents(prev => [
        ...prev,
        ...(skillProgressReportStudents?.nodes?.map(node => ({
          id: node?.id,
          firstName: node?.firstName,
          lastName: node?.lastName,
          publicUserId: node?.publicUserId,
        })) as Student[]),
      ]);
    }
  }, [studentSkillProgressDetailInput, lazyLoading, skillProgressReportStudents]);
  return <div style={{ display: 'none' }}></div>;
};

export default QuerySkillsProgressReportStudents;
